import { DashboardFolderT, DashboardT } from 'business/definitions';

import { checkStringMatch } from 'routes/Library/helpers';

const getSearchBarFilter = (searchValue: string) => (dash: DashboardT) =>
    checkStringMatch(dash.title, searchValue);

const folderNameFilter = (searchValue: string) => (folder: DashboardFolderT) =>
    checkStringMatch(folder.name, searchValue);

/**
 * Filters a list of dashboard folders based on a search value if searching is active.
 *
 * @param dashboardFoldersList - The list of dashboard folders to filter.
 * @param searchValue - The search string used to filter the dashboards.
 * @returns The filtered list of dashboard folders if searching is active, otherwise the original list.
 */
export const filterDashboardsFoldersBySearch = (
    dashboardFoldersList: DashboardFolderT[],
    searchValue: string,
) =>
    searchValue
        ? dashboardFoldersList.filter(folderNameFilter(searchValue))
        : dashboardFoldersList;

/**
 * Filters a list of dashboards based on a search value if searching is active.
 *
 * @param dashboardsList - The list of dashboards to filter.
 * @param searchValue - The search string used to filter the dashboards.
 * @param filterOutFolders - A boolean indicating whether to filter out folders
 *                          when the search value is empty.
 * @returns The filtered list of dashboards if searching is active, otherwise the original list.
 */
export const filterDashboardsBySearch = (
    dashboardsList: DashboardT[],
    searchValue: string,
    filterOutFolders: boolean = false,
) =>
    dashboardsList.filter((dashboard) => {
        if (searchValue !== '') {
            return getSearchBarFilter(searchValue)(dashboard);
        } else {
            return filterOutFolders ? !dashboard.folder : true;
        }
    });
